import { TItemDescriptions } from 'factions/factionTypes'
import { tagAs } from 'factions/metatagger'
import {
  BATTLESHOCK_PHASE,
  COMBAT_PHASE,
  HERO_PHASE,
  SAVES_PHASE,
  SHOOTING_PHASE,
  WOUND_ALLOCATION_PHASE,
} from 'types/phases'

const Prayers = {
  'Lore of the Spirit-Song': {
    effects: [
      {
        name: `Song of the Lost: Chant value of 4 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Sylvaneth Priest to chant this prayer, pick a friendly Sylvaneth unit that is wholly within the creeping overgrowth or that is visible to them and wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: Until the start of your next turn, subtract 1 from wound rolls for attacks that target that friendly unit. In addition, if the chanting roll was 8+:
        If the target is a Monster, Heal (3) the target.
        If the target is not a Monster, ignore modifiers to save rolls for the target (positive and negative) until the start of your next turn.`,
        when: [HERO_PHASE],
      },
      {
        name: `Song of War: Chant value of 5`,
        desc: `Declare: Pick a friendly Sylvaneth Priest to chant this prayer, pick a friendly Sylvaneth unit that is wholly within the creeping overgrowth or that is visible to them and wholly within 12" of them to be the target, then make a chanting roll of D6. 
        Effect: If the chanting roll was 10+, you can pick another eligible unit to be a second target. Until the start of your next turn, add 1 to the Rend characteristic of the target(s) melee weapons.`,
        when: [HERO_PHASE],
      },
      {
        name: `Song of Dread: Chant value of 4`,
        desc: `Declare: Pick a friendly Sylvaneth Priest to chant this prayer, pick an enemy unit that is wholly within the creeping overgrowth or that is visible to them and within 18" of them to be the target, then make a chanting roll of D6. 
        Effect: If the chanting roll was 8+, you can pick another eligible unit to be a second target. Until the start of your next turn, each time a target uses a Move ability and ends that move within the creeping overgrowth, inflict D3 mortal damage on that target after that Move ability has been resolved.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Lord of the Clans (AoR)': {
    effects: [
      {
        name: `Song of Persistence: Chant value of 3 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Lords of the Clan Priest to chant this prayer, pick a friendly Lords of the Clan Monster that is wholly within the creeping overgrowth or that is visible to them and wholly within 12" of them to be the target, then make a chanting roll of D6.
        Effect: Until the start of your next turn, ignore the effect of the 'Battle Damaged' ability on the target. In addition, if the chanting roll was 6+, the target has Ward (6+) until the start of your next turn.`,
        when: [HERO_PHASE],
      },
    ],
  },
  'Soulpod Guardians (AoR)': {
    effects: [
      {
        name: `Song of Vengeance: Chant value of 3 (UNLIMITED)`,
        desc: `Declare: Pick a friendly Soulpod Guardians Priest to chant this prayer, pick a visible friendly Soulpod Guardians unit that is wholly within 12" of them and not in combat or that is wholly within 12" of your Soulpod Grove to be the target, then make a chanting roll of D6.
        Effect: If the chanting roll was 8+, you can pick another eligible unit to be a second target. The target(s) can move up to 5" and can end that move in combat.`,
        when: [HERO_PHASE],
      },
    ],
  },
} satisfies TItemDescriptions

export default tagAs(Prayers, 'prayer')
